export enum EnumAutomationStatus {
  Active = 'active',
  Paused = 'paused',
  Unknown = 'unknown'
}
